<template>
  <select @change="switchLanguage">
    <option
      v-for="lang in supportedLocales"
      :key="`lang-${lang}`"
      :value="lang"
      :selected="locale === lang"
    >
    {{ $t(`locale.${lang}`) }}
    </option>
  </select>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import Translation from '@/i18n/translation'
import { watch } from 'vue'
import { useCodelistStore } from '@/stores/codelist'

const { locale } = useI18n()
const router = useRouter()
const supportedLocales = Translation.supportedLocales
const codelistStore = useCodelistStore()

const switchLanguage = async e => {
  const newLocale = e.target.value
  await Translation.switchLanguage(newLocale)

  try {
    await router.replace({ params: { locale: newLocale } })
  } catch (e) {
    console.error(e)
    router.push('/')
  }
}

watch(locale, async (newLocale) => {
  await codelistStore.fetchCodelist(newLocale)
})
</script>

<style lang="scss" scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: #ffffff;
  border: none;
  color: #0c7cac;
  cursor: pointer;
  display: inline;
  font-size: 0.6rem;
  height: 1.6rem;
  margin: 0 0.5rem 0 0;
  padding: 0 0.5rem;

  &:hover, &:focus {
    text-decoration: underline;
  }

  svg {
    pointer-events: none;
  }
}
</style>
